<template>
  <div class="fieldset-text-number-parts">
    <label :for="id">
      <span class="label-text">{{ label }}</span>
      <span class="required" v-if="required">{{ $t('formParts.required') }}</span>
    </label>

    <div
      :ref="refElement"
      class="fieldset-text-number-parts__input"
      :class="{ 'fieldset-text-number-parts__input--error': showError }"
    ></div>

    <form-error-message-parts
      :showError="showError"
      :message="errorMessage !== '' ? errorMessage : $t('formParts.errorMessage.textNumber')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from '@vue/composition-api'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'

type RefElementType = 'numberElement' | 'expiryElement' | 'cvcElement'

/**
 * フィールドセット テキスト(数字) バーツ
 */
export default defineComponent({
  name: 'FieldsetTextCreditParts',
  components: {
    FormErrorMessageParts,
  },
  props: {
    /**
     * データタイトル
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * 入力データ
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * カード情報を入力するElement
     */
    refElement: {
      type: String as PropType<RefElementType>,
      default: '',
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {
    /** props.refElementで渡ってきたものと同じプロパティの場合、onMounted後にTemplate ref経由で取得される */
    const paymentElements = {
      /**
       * カード番号を入力するElement
       * onMounted後にTemplate ref経由でここに取得される
       */
      numberElement: ref(null),
      /**
       * カード有効期限を入力するElement
       * onMounted後にTemplate ref経由でここに取得される
       */
      expiryElement: ref(null),
      /**
       * CVCを入力するElement
       * onMounted後にTemplate ref経由でここに取得される
       */
      cvcElement: ref(null),
    }

    return {
      ...paymentElements,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-text-number-parts {
  @include fieldSet();

  &__input {
    width: 100%;
    min-height: 3.69em;
    padding: 1em 1.23em;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #c7c7c7;

    /** ブランクかつフォーカスが当たってない場合はテキスト欄の背景をグレーにする */
    &.StripeElement.empty {
      &:not(.focused) {
        background: rgba(0, 0, 0, 5%);
      }
    }

    &--error {
      border-color: rgba(255, 46, 0, 0.5);
    }
  }
}
</style>
